import {
    styled,
    $fontWeightLight,
    $fontSize,
    $error,
} from '@acko-tech/building-blocks.ui.common';

export const Input = styled.input`
    border: 1px solid #d6d9e0;
    border-radius: 8px;
    padding: 1.18em 3em 1.18em 1.18em;
    font-size: ${$fontSize.xs};
    width: 100%;
    height: 100%;
    outline: none;
    text-transform: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ::placeholder {
        font-weight: ${$fontWeightLight};
        font-size: ${$fontSize.xs};
        line-height: 18px;
        color: #5b5675;
        text-transform: none;
    }
    :focus {
        border: 1px solid #4f34d2;
    }
    text-transform: ${(props) => (props.autoCapitalize ? 'uppercase' : 'none')};
    ${(props) => props.isDesktop && 'height: 55px'};
    ${(props) => props.pointerCursor && 'cursor: pointer'};
    ${(props) => props.leftPadding && 'padding: 1.18em 3em 1.18em 3.5em;'}
    ${(props) => props.isPrefix && 'padding-left: 38px'};
    ${(props) => props.styles}
`;

export const Label = styled.p`
    margin: 0px;
    font-weight: ${$fontWeightLight};
    font-size: ${$fontSize.xxs};
    line-height: 15px;
    letter-spacing: 0.04em;
    display: inline-block;
    background-color: white;
    padding: 0 5px;
    transition: all 0.3s;
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(0.8em, -0.6em);
    ${(props: any) => (props.focused ? `color: #4f34d2` : `color: #5B5675`)}
    ${Input}:placeholder-shown ~ & {
        visibility: hidden;
        opacity: 0;
        transform: translate(0.8em, 1.4em);
    }
    // ${(props) => props.styles}
`;

export const InputWrapper = styled.div`
    position: relative;
    margin-top: ${(props) => (props.isDesktop ? '1.875rem' : '1.5rem')};
    width: 100%;
    ${(props) => props.styles}
`;

export const Note = styled.p`
    font-weight: ${$fontWeightLight};
    font-size: 0.7rem;
    color: #555a68;
    padding: 8px 1em 0;
    box-sizing: border-box;
    ${(props) => props.error && `padding-top: 4px;`}
    padding-left: ${(props) => props.isDesktop && '10px'};
`;

export const ErrorText = styled.p`
    line-height: 16px;
    width: 90%;
    color: ${$error};
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    margin: ${(props) => props.margin && props.margin};
    text-align: left;
`;

export const DropDown = styled.div`
    width: 0.55em;
    height: 0.55em;
    transform: rotate(45deg);
    border-right: 1.5px solid #151619;
    border-bottom: 1.5px solid #151619;
    display: inline;
    position: absolute;
    top: 40%;
    right: 1.5em;
    cursor: pointer;
`;

export const ImageContainer = styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 1.5em;
    cursor: pointer;
`;

export const MobilePrefix = styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
    font-size: ${$fontSize.xs};
`;
